/* eslint-disable max-len */
/* eslint-disable no-use-before-define */
/* eslint-disable react/jsx-no-duplicate-props */
import React, {
  useContext, useEffect, useRef, useState,
} from 'react';
import {
  AccessAlarmRounded,
  AccessTime,
  AccessTimeRounded,
  AddCircleOutlineRounded,
  CalendarMonthRounded,
  CalendarTodayOutlined,
  DeleteOutlineRounded,
  InfoOutlined,
  LocationOnOutlined,
  RemoveCircleOutlineRounded,
} from '@mui/icons-material';
import {
  Box, Button, CircularProgress, Container, Divider, Drawer, IconButton, MenuItem, TextField,
} from '@mui/material';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
// import Images from '../../../../Configs/images';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import ROUTES from '../../../../Configs/routes';
import AlertContext from '../../../../Context/AlertContext';
import Elements from '../../../Elements';
import Images from '../../../../Configs/images';
import { AddressBoxes } from '../AddressList/AddressList';
import { getAddress } from '../../../../Redux/Models/address';
import { getUserData, setUserData } from '../../../../Utils/storages';
import { createRequestIn, updateRequestIn } from '../../../../Redux/Models/request';
import ConfirmationContext from '../../../../Context/ConfirmationContext';
import { IconBottle, IconStorage } from '../../../../Assets/Icons';
import { onlyNumbers } from '../../../../Utils/helpers';
import { getVolumeUnit } from '../../../../Redux/Models/master';
import ReqInContext from '../../../../Context/ReqInContext';

export default function RequestIn({
  classes, error, message, newRequest, isLoading, newRequestData,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rootRef = useRef(null);
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  const editStep = searchParams.get('edit_step');
  const selectedReq = searchParams.get('selected_req');

  const { address, master } = useSelector((state) => state);
  const { openAlert } = useContext(AlertContext);
  const userData = getUserData();
  const { openConfirmation, closeConfirmation } = useContext(ConfirmationContext);

  const { isLoadingVolumeUnit, volumeUnit } = master;

  const quota = userData.quota || 0;
  const totalQuota = userData.total_quota || 0;
  const usedQuota = totalQuota - quota;

  const defaultItem = {
    name: '',
    volume: null,
    tempVolume: '0',
    year: null,
  };

  const defaultBox = {
    name: '',
    amount: 1,
    dimension: '',
    notes: '',
    type: '-',
  };

  const {
    data: items = [],
    setReqInData: setItems,
    step = 1,
    setStep,
    boxData: boxes = [],
    setReqInBoxData: setBoxes,
  } = useContext(ReqInContext);

  const [openChangeAddress, setOpenChangeAddress] = useState(false);
  const [openBookPickup, setOpenBookPickup] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [openTooltip, setOpenTooltip] = useState(false);
  const [openTooltip2, setOpenTooltip2] = useState(false);
  const [openTooltipBookPickup, setOpenTooltipBookPickup] = useState(false);
  const [type, setType] = useState('Box');
  // const [bookPickup, setBookPickup] = useState(null);

  const [steps] = useState([
    { name: t('reqIn.step1'), tooltip: t('reqIn.tip1'), icon: Images.IconDetailItem },
    { name: t('reqIn.step2'), tooltip: t('reqIn.tip2'), icon: Images.IconLocation },
    { name: t('reqIn.step3'), tooltip: t('reqIn.tip3'), icon: Images.IconConfirmation },
  ]);

  const [fields, setFields] = useState({
    pickup_address: {},
    pickup_date: new Date(),
    pickup_notes: '',
  });

  const [book, setBook] = useState({
    pickup_date: moment().add(1, 'days').toDate(),
    reminder: null,
  });

  const isBookPickup = fields.reminder;

  useEffect(() => {
    if (editStep) {
      setStep(Number(editStep));
    }
  }, [editStep]);

  useEffect(() => {
    if (selectedReq) {
      const selectedReqData = JSON.parse(selectedReq);
      if (selectedReqData.items) {
        setItems(selectedReqData.items);
      }

      if (selectedReqData.box) {
        setBoxes(selectedReqData.box || []);
      } else {
        setBoxes([]);
      }

      if (selectedReqData.type) {
        setType(selectedReqData.type);
      }

      if (selectedReqData.address) {
        setFields({
          ...fields,
          pickup_address: selectedReqData.address,
          pickup_notes: selectedReqData.pickup_notes,
        });
      }

      if (selectedReqData.pickup_date) {
        setBook({
          pickup_date: new Date(selectedReqData.pickup_date),
          reminder: true,
        });
      }
    }
  }, [selectedReq]);

  const handleSetType = (newType) => {
    setType(newType);
  };

  const handleSetBookPickup = () => {
    setFields({ ...fields, ...book });
    setOpenBookPickup(false);
  };

  useEffect(() => {
    if (address.data.length && !fields.pickup_address?.id) {
      const selectedAddress = address.data.filter((addr) => addr.is_default)[0];
      setFields({
        ...fields,
        pickup_address: selectedAddress,
      });
    }
  }, [address]);

  useEffect(() => {
    dispatch(getAddress(userData.id));
    dispatch(getVolumeUnit());
  }, []);

  const takeAddress = (add) => {
    setFields({ ...fields, pickup_address: add });
    setOpenChangeAddress(false);
  };

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  // const [items, setItems] = useState(() => [
  //   { ...defaultItem, id: Date.now() },
  // ]);

  const addItem = () => {
    setItems([...items, { ...defaultItem, id: Date.now() }]);
  };

  const addBox = () => {
    setBoxes([...boxes, { ...defaultBox, id: Date.now() }]);
  };

  const deleteItem = (itemId) => {
    setItems(items.filter((item) => item.id !== itemId));
  };

  const deleteBox = (boxId) => {
    setBoxes(boxes.filter((box) => box.id !== boxId));
  };

  const renderLeftBtnText = () => {
    if (step === 1) {
      return t('common.cancel');
    }
    if (step === 2) {
      return t('common.back');
    }
    if (step === 3 && isBookPickup) {
      return t('reqIn.cancelBook');
    }
    return t('reqIn.book');
  };

  const renderRightBtnText = () => {
    if (step === 3 && isBookPickup) {
      return t('reqIn.book');
    }
    if (step === 3) {
      return t('reqIn.now');
    }
    return t('common.next');
  };

  const handleClickLeftBtn = () => {
    if (step === 1) {
      handleShowBackAlert();
    } else if (step === 2) {
      setStep((prev) => prev - 1);
    } else if (step === 3 && isBookPickup) {
      openConfirmation({
        handleAgree: () => {
          setFields({
            ...fields,
            reminder: null,
            pickup_date: new Date(),
          });
          closeConfirmation();
        },
        title: t('reqIn.cancelBook'),
        desc: 'Change mind? Worry not! you can change pick up method.',
        confirmText: 'Change pick up method',
      });
    } else {
      // handle book pick up
      setOpenBookPickup(true);
    }
  };

  const handleClickRightBtn = () => {
    if (totalQuota === usedQuota) {
      openAlert({
        message: 'You have no quota left',
        severity: 'error',
      });
      return;
    }
    setSubmitted(true);
    if (step === 1) {
      const itemsPassed = items.every((item) => (item.volume || !['-', '0'].includes(item.tempVolume)) && item.name && item.year);
      const boxesPassed = (boxes.every((box) => box.dimension && box.amount) && itemsPassed) || !boxes.length;

      if (!itemsPassed || !boxesPassed) {
        openAlert({
          title: `${type} details not completed`,
          message: 'Please fill in all required fields or remove unnecessary item/box fields!',
          severity: 'error',
        });
        return;
      }

      if (!items.length && !boxes.length) {
        openAlert({
          title: 'Minimum 1 item/box needed for request in',
          message: 'Please fill in all required fields!',
          severity: 'error',
        });
        return;
      }
    }
    if (step === 2 && !fields.pickup_address) {
      openAlert({
        title: 'No address selected',
        message: 'Please choose pickup address or create new address first',
        severity: 'error',
      });
      return;
    }
    if (step === 3) {
      // handle pick up now
      const cleanItems = items.map((item) => {
        if (item.tempVolume === '-') {
          return { ...item, volume: `${item.volume} mL` };
        }
        return { ...item, volume: item.tempVolume };
      });

      const body = {
        items: cleanItems,
        box: boxes ?? [],
        pickup_date: fields.pickup_date,
        pickup_address: fields.pickup_address.id,
        owner_address: fields.pickup_address.id,
        owner: userData.id,
        is_box: true,
        reminder: fields.reminder || null,
        type,
        pickup_notes: fields.pickup_notes,
      };

      // if (type === 'Box') {
      //   body.is_box = true;
      //   body.box = boxes;
      //   setUserData({
      //     ...userData,
      //     quota: userData.quota - (boxes.length * 6),
      //   });
      // } else {
      //   setUserData({
      //     ...userData,
      //     quota: userData.quota - body.items.length,
      //   });
      // }

      setUserData({
        ...userData,
        quota: userData.quota - (body.items.length + boxes.length * 6),
      });

      const selectedReqData = JSON.parse(selectedReq);
      if (selectedReqData?.id) {
        dispatch(updateRequestIn(userData.id, selectedReqData.id, body));
      } else {
        dispatch(createRequestIn(userData.id, body));
      }
      return;
    }
    setStep((prev) => prev + 1);
    if (rootRef.current) rootRef.current.scrollIntoView();
  };

  useEffect(() => {
    if (newRequest && submitted) {
      openAlert({
        title: isBookPickup ? 'Book request order placed' : 'Request order placed',
        message: 'Your order will confirm soon, please wait!',
        severity: 'success',
      });
      setItems([]);
      setBoxes([]);
      setStep(1);
      if (newRequestData?.id) navigate(`${ROUTES.history()}/${newRequestData.id}`, 'replace');
    }
  }, [error, newRequest]);

  const handleShowBackAlert = () => {
    openConfirmation({
      handleAgree: () => {
        closeConfirmation();
        navigate(-1);
        setItems([]);
        setBoxes([]);
      },
      title: 'Cancel progress?',
      desc: 'Your information progress will not be saved',
      confirmText: 'Confirm',
    });
  };

  const renderAddress = () => (
    <Box mt={1.5} p={1.5} border="1px solid #E5E5E5" borderRadius={2}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <div className="weight-700">{fields.pickup_address?.label}</div>
        <div className="weight-600 primary-green link" onClick={() => setOpenChangeAddress(true)}>Change</div>
      </Box>
      <Box mt={1}>
        <div className="s-12">{fields.pickup_address?.name}</div>
        <div className="s-12 mt-1">
          +
          {fields.pickup_address?.phone_number}
        </div>
      </Box>
      <Box mt={0.5} bgcolor="#F5F6F8" borderRadius={1} py={0.5} px={1} display="flex" alignItems="flex-start" gap={1}>
        <LocationOnOutlined fontSize="small" />
        <div className="s-12">
          {fields.pickup_address.address}
          ,
          {' '}
          {fields.pickup_address.city}
          ,
          {' '}
          {fields.pickup_address.province}
          ,
          {' '}
          {fields.pickup_address.country}
          ,
          {' '}
          {fields.pickup_address.postal_code}
        </div>
      </Box>
    </Box>
  );

  const renderItems = () => items.map((item, index) => (
    <div key={item.id}>
      <Box className="weight-700 s-14" mt={2} display="flex" justifyContent="space-between">
        <Box>
          {t('common.item')}
          {' '}
          {index + 1}
        </Box>
        {(items.length > 1 || type === 'Box')
          && (
            <IconButton sx={{ p: 0 }} onClick={() => deleteItem(item.id)}>
              <DeleteOutlineRounded />
            </IconButton>
          )}
      </Box>
      <div className="s-14 weight-600 mt-2">
        {t('reqIn.field3')}
        <span className="primary-green">*</span>
      </div>
      <TextField
        value={item.name}
        sx={{ mt: 0.5 }}
        size="small"
        placeholder="Type wine name"
        fullWidth
        onChange={(e) => {
          const newItems = items.map((i) => {
            if (i.id === item.id) {
              return { ...i, name: e.target.value };
            }
            return i;
          });

          setItems(newItems);
        }}
      />
      {submitted && !item.name
      && <Box className="error weight-600 s-14">Wine name is required</Box>}

      <div className="s-14 weight-600 mt-3">
        {t('reqIn.field4')}
        <span className="primary-green">*</span>
      </div>
      <TextField
        value={item.year}
        sx={{ mt: 0.5 }}
        size="small"
        placeholder="Type the year"
        fullWidth
        onChange={(e) => {
          const newItems = items.map((i) => {
            if (i.id === item.id) {
              return { ...i, year: Number(onlyNumbers(e.target.value)) };
            }
            return i;
          });

          setItems(newItems);
        }}
      />
      {submitted && !item.year
      && <Box className="error weight-600 s-14">Year of the wine is required</Box>}

      <div className="s-14 weight-600 mt-3">
        {t('reqIn.field5')}
        <span className="primary-green">*</span>
      </div>
      <TextField
        sx={{ mt: 0.5 }}
        size="small"
        placeholder="0"
        fullWidth
        value={item.tempVolume ?? item.volume}
        onChange={(e) => {
          const newItems = items.map((i) => {
            if (i.id === item.id) {
              return { ...i, tempVolume: e.target.value };
            }
            return i;
          });

          setItems(newItems);
        }}
        select
      >
        <MenuItem value="0" disabled>{isLoadingVolumeUnit ? 'Loading...' : 'Choose wine volume'}</MenuItem>
        {volumeUnit.map((unit) => (
          <MenuItem value={unit.option} key={unit.id}>{unit.option}</MenuItem>
        ))}
        <MenuItem value="-">{t('common.other')}</MenuItem>
      </TextField>
      {submitted && item.tempVolume === '0'
      && <Box className="error weight-600 s-14">Wine volume is required</Box>}
      {item.tempVolume === '-'
      && (
      <>
        <TextField
          value={item.volume}
          InputProps={{
            endAdornment: 'ml',
          }}
          sx={{ flex: 3, mt: 0.5 }}
          size="small"
          placeholder="Type your wine volume"
          fullWidth
          onChange={(e) => {
            const newItems = items.map((i) => {
              if (i.id === item.id) {
                return { ...i, volume: Number(onlyNumbers(e.target.value)) };
              }
              return i;
            });

            setItems(newItems);
          }}
        />
        {submitted && !item.volume
          && <Box className="error weight-600 s-14">Wine volume is required</Box>}
      </>
      )}
      <Divider sx={{ borderWidth: 3, borderColor: '#F5F6F8', my: 2 }} />
    </div>
  ));

  const renderBoxes = () => boxes.map((box, index) => (
    <div key={index}>
      <Box className="weight-700 s-14" mt={2} display="flex" justifyContent="space-between">
        <Box>
          Box
          {' '}
          {index + 1}
        </Box>
        <IconButton sx={{ p: 0 }} onClick={() => deleteBox(box.id)}>
          <DeleteOutlineRounded />
        </IconButton>
      </Box>
      <div className="s-14 weight-600 mt-2">
        {t('reqIn.field1')}
        <span className="primary-green">*</span>
      </div>
      <TextField
        fullWidth
        size="small"
        sx={{ mt: 0.5 }}
        value={box.dimension}
        onChange={({ target }) => {
          const newBoxes = boxes.map((i) => {
            if (i.id === box.id) {
              return { ...i, dimension: target.value };
            }
            return i;
          });

          setBoxes(newBoxes);
        }}
      />
      {submitted && !box.dimension && <Box className="error weight-600 s-14">Dimension is required</Box>}

      <div className="s-14 weight-600 mt-2">
        {t('reqIn.field')}
        <span className="primary-green">*</span>
      </div>
      <TextField
        fullWidth
        size="small"
        sx={{ mt: 0.5 }}
        value={box.type}
        onChange={({ target }) => {
          const newBoxes = boxes.map((i) => {
            if (i.id === box.id) {
              return { ...i, type: target.value, amount: 1 };
            }
            return i;
          });

          setBoxes(newBoxes);
        }}
        select
      >
        <MenuItem value="-" disabled>Choose box type</MenuItem>
        <MenuItem value="1x3">1x3 Bottles</MenuItem>
        <MenuItem value="1x6" disabled={quota < 6}>1x6 Bottles</MenuItem>
        <MenuItem value="2x3" disabled={quota < 6}>2x3 Bottles</MenuItem>
        <MenuItem disabled={quota < 12} value="2x6">2x6 Bottles</MenuItem>
      </TextField>
      {submitted && box.type === '-' && <Box className="error weight-600 s-14">Type is required</Box>}

      <div className="s-14 weight-600 mt-3">
        {t('reqIn.field2')}
        <span className="primary-green">*</span>
      </div>
      <TextField
        fullWidth
        size="small"
        value={box.amount}
        onChange={({ target }) => {
          const realVal = Number(onlyNumbers(target.value));
          const newBoxes = boxes.map((i) => {
            let max = 6;
            if (box.type === '1x3') max = 3;
            if (box.type === '2x6') max = 12;
            if (i.id === box.id && realVal >= 1 && realVal <= max) {
              return { ...i, amount: realVal };
            }
            return i;
          });

          setBoxes(newBoxes);
        }}
        InputProps={{
          startAdornment: (
            <IconButton
              sx={{ p: 0, color: '#404852' }}
              onClick={() => {
                const newBoxes = boxes.map((i) => {
                  if (i.id === box.id) {
                    return {
                      ...i,
                      amount: Number(box.amount > 1 ? box.amount - 1 : 1),
                    };
                  }
                  return i;
                });
                setBoxes(newBoxes);
              }}
            >
              <RemoveCircleOutlineRounded />
            </IconButton>
          ),
          endAdornment: (
            <IconButton
              sx={{ p: 0, color: '#404852' }}
              onClick={() => {
                const newBoxes = boxes.map((i) => {
                  if (i.id === box.id) {
                    let max = 6;
                    if (box.type === '1x3') max = 3;
                    if (box.type === '2x6') max = 12;
                    return {
                      ...i,
                      amount: Number(box.amount < max ? box.amount + 1 : max),
                    };
                  }
                  return i;
                });
                setBoxes(newBoxes);
              }}
            >
              <AddCircleOutlineRounded />
            </IconButton>
          ),
        }}
        inputProps={{ min: 0, style: { textAlign: 'center' } }}
        sx={{ mt: 0.5 }}
      />
      {submitted && !box.amount && <Box className="error weight-600 s-14">Box amount is required</Box>}
      <Divider sx={{ borderWidth: 3, borderColor: '#F5F6F8', my: 2 }} />
    </div>
  ));

  const checkQuota = (isBox = true) => {
    const boxTotal = boxes.reduce((sum, item) => sum + (item.type === '1x3' ? 3 : 6), 0);
    return isBox ? quota >= (boxTotal + items.length + 3) : quota > (items.length + boxTotal);
  };

  return (
    <Elements.PageBase navigate={navigate} noNav>
      <Elements.Navigator
        title={t('common.reqIn')}
        onBack={handleShowBackAlert}
        secondaryBtn={(
          <Elements.TooltipBase
            message={t('reqIn.reqInNote')}
            open={openTooltip}
            onClick={() => setOpenTooltip(true)}
            onClose={() => setOpenTooltip(false)}
            icon={<InfoOutlined className="black" fontSize="small" />}
          />
        )}
      />
      <div className={classes.root} ref={rootRef}>
        {!!steps[step - 1]
          && (
            <Box bgcolor="#F5F6F8" py={1.5} component={Container} display="flex" justifyContent="space-between" alignItems="center">
              <Box display="flex" alignItems="center" gap={1}>
                <img src={steps[step - 1].icon} alt="detail item" />
                <Box>
                  <div className="mute s-10">
                    {t('reqIn.step', { count: step, totalStep: 3 })}
                  </div>
                  <div className="s-14 weight-700">
                    {steps[step - 1].name}
                  </div>
                </Box>
              </Box>
              <Elements.TooltipBase
                message={steps[step - 1].tooltip}
                open={openTooltip2}
                onClick={() => setOpenTooltip2(true)}
                onClose={() => setOpenTooltip2(false)}
                icon={<InfoOutlined className="mute" sx={{ fontSize: 14 }} />}
              />
            </Box>
          )}

        <Container>
          <Elements.StorageQuota mt={1} />
        </Container>

        <Divider
          sx={{
            borderWidth: 3,
            borderColor: '#F5F6F8',
            mb: 3,
            mt: 1,
          }}
        />

        {step === 1
          && (
            <Container>
              <Box display="none" justifyContent="space-between" gap={1} alignItems="center">
                <Button className={type === 'Item' ? 'btn-contained' : 'btn-outlined'} variant={type === 'Item' ? 'contained' : 'outlined'} display="flex" gap={1.5} alignItems="center" fullWidth onClick={() => handleSetType('Item')}>
                  <Box color="transparent" display="inline-flex">
                    <IconBottle iconcolor={type === 'Box' ? '#2E3C40' : '#fff'} />
                  </Box>
                  <Box>{t('common.item')}</Box>
                </Button>
                <Button
                  className={type === 'Box' ? 'btn-contained' : 'btn-outlined'}
                  variant={type === 'Box' ? 'contained' : 'outlined'}
                  display="flex"
                  gap={1.5}
                  alignItems="center"
                  fullWidth
                  onClick={() => handleSetType('Box')}
                  disabled={quota < 6}
                >
                  <Box color="transparent" display="inline-flex">
                    <IconStorage iconcolor={type === 'Item' ? '#2E3C40' : '#fff'} />
                  </Box>
                  <Box>Box</Box>
                </Button>
              </Box>
              <Box mt={2} color="#404852" fontSize={12}>{t('reqIn.desc1')}</Box>
              <Box mt={2}>
                <div className="s-18 weight-600">
                  {t('common.boxes')}
                  :
                </div>
                {renderBoxes()}
                {checkQuota() ? <Box className="primary-green s-14 weight-600 link" onClick={addBox} mt={2}>{t('reqIn.addMoreBox')}</Box> : t('reqIn.needMoreStorage')}

                <div className="s-18 weight-600 mt-5">
                  {t('common.items')}
                  :
                </div>
                {renderItems()}
                { checkQuota(false) ? <Box className="primary-green s-14 weight-600 link" onClick={addItem} mt={2}>{t('reqIn.addMoreItem')}</Box> : t('reqIn.needMoreStorage')}
              </Box>
              <div className="s-14 weight-600 mt-4">
                {t('reqIn.field6')}
              </div>
              <TextField
                sx={{ mt: 0.5 }}
                size="small"
                multiline
                fullWidth
                placeholder="Notes if any"
                value={fields.pickup_notes}
                onChange={({ target }) => setFields({ ...fields, pickup_notes: target.value })}
              />
            </Container>
          )}

        {step === 2
          && (
            <Container>
              {fields.pickup_address?.address ? renderAddress()
                : (
                  <Box mt={1.5} px={1.5} py={2} border="1px solid #E5E5E5" borderRadius={2}>
                    <Elements.Info message={(
                      <span>
                        {t('reqIn.noAdd')}
                      </span>
                    )}
                    />
                    <Button variant="contained" className="btn-contained" fullWidth sx={{ mt: 1.5 }} onClick={() => navigate(`${ROUTES.address()}/update`)}>{t('address.create')}</Button>
                  </Box>
                )}
            </Container>
          )}

        {step === 3
          && (
            <Container>
              <div className="mt-3 s-14 weight-700">{t('reqIn.itemsDetail')}</div>
              {items.length && (
                <Box mt={1.5} border="1px solid #E5E5E5" borderRadius={2} p={1.5}>
                  {items.map((item, idx) => (
                    <Box mt={0.5} bgcolor="#F5F6F8" borderRadius={1} py={0.5} px={1} key={item.id}>
                      <div className="s-12 weight-700">
                        {t('common.item')}
                        {' '}
                        {idx + 1}
                      </div>
                      <Box display="flex" alignItems="flex-start" mt={0.5}>
                        <Box flex={2}>
                          <div className="mute s-10">{t('reqIn.field3')}</div>
                          <div className="s-12 weight-600">{item.name}</div>
                        </Box>
                        <Box flex={1}>
                          <div className="mute s-10">{t('reqIn.field5')}</div>
                          <div className="s-12 weight-600">
                            {item.tempVolume !== '-' ? item.tempVolume : `${item.volume} mL`}
                          </div>
                        </Box>
                      </Box>
                    </Box>
                  ))}

                  <Box textAlign="right" mt={1}>
                    <div className="weight-600 primary-green link" onClick={() => setStep(1)}>{t('common.change')}</div>
                  </Box>
                </Box>
              )}

              {!!boxes.length && (
                <Box mt={1.5} border="1px solid #E5E5E5" borderRadius={2} p={1.5}>
                  <Box mt={0.5} bgcolor="#F5F6F8" borderRadius={1} py={0.5} px={1}>
                    <div className="s-12 weight-700">
                      {t('common.boxes')}
                      :
                      {' '}
                      {boxes.length}
                    </div>
                    <Box display="flex" alignItems="flex-start" mt={0.5}>
                      <Box flex={2}>
                        <div className="mute s-10">
                          {t('common.notes')}
                          :
                        </div>
                        <div className="s-12 weight-600">{fields.pickup_notes}</div>
                      </Box>
                    </Box>
                  </Box>
                  <Box textAlign="right" mt={1}>
                    <div className="weight-600 primary-green link" onClick={() => setStep(1)}>{t('common.change')}</div>
                  </Box>
                </Box>
              )}
              <div className="mt-3 s-14 weight-700">{t('reqIn.owner')}</div>
              {renderAddress()}
              {!!isBookPickup && (
                <>
                  <div className="mt-3 s-14 weight-700">{t('reqIn.bookDetails')}</div>
                  <Box mt={1.5} border="1px solid #E5E5E5" borderRadius={2} p={1.5}>
                    <Box mt={0.5} display="flex" justifyContent="space-between" alignItems="center">
                      <Box display="flex" gap={0.5} alignItems="center">
                        <CalendarTodayOutlined sx={{ fontSize: 12 }} />
                        <Box className="s-12 weight-600">{moment(fields.pickup_date).format('DD MMM YYYY')}</Box>
                      </Box>
                      <Box display="flex" gap={0.5} alignItems="center">
                        <AccessTimeRounded sx={{ fontSize: 12 }} />
                        <Box className="s-12 weight-600">{moment(fields.pickup_date).format('HH.mm')}</Box>
                      </Box>
                      <Box display="flex" gap={0.5} alignItems="center">
                        <AccessAlarmRounded sx={{ fontSize: 12 }} />
                        <Box className="s-12 weight-600">
                          {fields.reminder}
                          {' '}
                          minutes before
                        </Box>
                      </Box>
                    </Box>

                    <Box textAlign="right" mt={1}>
                      <div className="weight-600 primary-green link" onClick={() => setOpenBookPickup(true)}>{t('common.change')}</div>
                    </Box>
                  </Box>
                </>
              )}
            </Container>
          )}
      </div>

      <Container sx={{ pb: 2, mt: 3 }}>
        <Box className="s-12">
          {t('common.read')}
          {' '}
          <Link to={ROUTES.termsConditions()} style={{ color: '#38AC3D' }}>{t('common.tor')}</Link>
        </Box>
        <Box mt={1.5} display="flex" justifyContent="space-between" gap={1}>
          <Button variant="outlined" className="btn-outlined " fullWidth onClick={handleClickLeftBtn}>{renderLeftBtnText()}</Button>
          <Button
            variant="contained"
            className="btn-contained "
            fullWidth
            onClick={handleClickRightBtn}
            disabled={isLoading}
            startIcon={isLoading && (<CircularProgress size={18} sx={{ mr: 1, color: '#fff' }} />)}
          >
            {renderRightBtnText()}
          </Button>
        </Box>
      </Container>

      <Drawer
        anchor="right"
        open={openChangeAddress}
        onClose={() => setOpenChangeAddress(false)}
      >
        <Elements.Navigator
          title="Change address"
          onBack={() => setOpenChangeAddress(false)}
          secondaryBtn={(
            <IconButton LinkComponent={Link} to={`${ROUTES.address()}/update`}>
              <AddCircleOutlineRounded fontSize="small" className="black" />
            </IconButton>
          )}
        />
        <Box maxWidth="375px" px={2} boxSizing="border-box">
          <AddressBoxes selectAddress={takeAddress} />
        </Box>
      </Drawer>
      <Drawer
        anchor="right"
        open={openBookPickup}
        onClose={() => setOpenBookPickup(false)}
      >
        <Elements.Navigator
          title="Book pick up"
          onBack={() => setOpenBookPickup(false)}
          secondaryBtn={(
            <Elements.TooltipBase
              message="By using booked pick-up service, you can choose to pick up wine anytime and on any date"
              open={openTooltipBookPickup}
              onClick={() => setOpenTooltipBookPickup(true)}
              onClose={() => setOpenTooltipBookPickup(false)}
              icon={<InfoOutlined className="black" fontSize="small" />}
            />
          )}
        />
        <Box minWidth="280px" maxWidth="375px" px={2} boxSizing="border-box">
          <div className="s-14 weight-600 mt-3">
            Choose pick up duration
            <span className="primary-green">*</span>
          </div>
          <DatePicker
            minDate={moment().add(1, 'days').toDate()}
            value={book.pickup_date}
            name="pickup_date"
            onChange={(val) => setBook({ ...book, pickup_date: val })}
            renderInput={(params) => (
              <TextField
                size="small"
                sx={{ mt: 1 }}
                fullWidth
                InputProps={{
                  endAdornment: (<CalendarMonthRounded />),
                }}
                {...params}
              />
            )}
          />
          <div className="s-14 weight-600 mt-3">
            Choose time
            <span className="primary-green">*</span>
          </div>
          <TimePicker
            // minDate={moment().add(1, 'days')}
            value={book.pickup_date}
            onChange={(val) => setBook({ ...book, pickup_date: val })}
            renderInput={(params) => (
              <TextField
                size="small"
                sx={{ mt: 1 }}
                fullWidth
                InputProps={{
                  endAdornment: (<AccessTime />),
                }}
                {...params}
              />
            )}
          />
          <div className="s-14 weight-600 mt-3">
            Reminder
            <span className="primary-green">*</span>
          </div>
          <TextField
            select
            size="small"
            fullWidth
            value={book.reminder}
            onChange={(e) => setBook({ ...book, reminder: e.target.value })}
          >
            <MenuItem value="30">30 minutes before</MenuItem>
            <MenuItem value="60">1 hour before</MenuItem>
            <MenuItem value="120">2 hours before</MenuItem>
          </TextField>

          <Button disabled={!book.reminder} variant="contained" className="btn-contained" fullWidth sx={{ mt: 3 }} onClick={handleSetBookPickup}>Confirm</Button>

        </Box>
      </Drawer>

      <Elements.Footer />
    </Elements.PageBase>
  );
}
